import React, { useEffect, useState } from "react";
import { AppBar, Box, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import { AccountCircle, MoreVert } from '@mui/icons-material';
import { MenuCustom } from './index';
import logo from '../assets/images/jazminmya.png';

const Header = ({ Child, options }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => clearInterval(id);
  }, []);

  const clockText = now.toLocaleTimeString('es-AR', {
    hour: '2-digit',
    minute: '2-digit',
    second: isMobile ? undefined : '2-digit',
    hour12: false,
  });

  const dateText = now.toLocaleDateString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: isMobile ? undefined : 'numeric',
  });

  return (
    <AppBar position="sticky" color="inherit" variant="elevation" sx={{background: '#fcf8f2', zIndex: 1000}}>
      <Toolbar sx={{ padding: 0, margin: 0 }}>
        {/* <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Mi Sitio Web
        </Typography> */}
        <Box display='flex' flexDirection='row' gap={3} alignItems='center' justifyContent='space-between' sx={{ width: '100%' }} >
          <Box display='flex' flexDirection='row' sx={{width: '95%'}}>
            <Child />
          </Box>
          <Box
            display='flex'
            flexDirection='row'
            alignItems='center'
            justifyContent='flex-end'
            gap={1}
            sx={{ width: isMobile ? '35%' : '18%' }}
          >
            <Box display='flex' flexDirection='column' alignItems='center' lineHeight={1.05}>
              <Typography
                variant='body2'
                sx={{
                  fontWeight: 900,
                  letterSpacing: 0.7,
                  color: '#3d2f1f',
                  textShadow: '0 1px 0 rgba(255,255,255,0.45)',
                  fontSize: isMobile ? '1.15rem' : '1.45rem',
                  minWidth: isMobile ? 58 : 86,
                  textAlign: 'center',
                }}
              >
                {clockText}
              </Typography>
              <Typography
                variant='caption'
                sx={{
                  mt: 0.2,
                  fontWeight: 700,
                  letterSpacing: 0.4,
                  color: '#7a6a53',
                  fontSize: isMobile ? '0.72rem' : '0.82rem',
                  textAlign: 'center',
                }}
              >
                {dateText}
              </Typography>
            </Box>
            {options ? 
              <MenuCustom
                Child={() => <AccountCircle />}
                options={options}
              //optionsSelected={(idoption) => optionSelected(idoption, article)}
              /> : 
              <Box display='flex' flexDirection='column' sx={{ textAlign: 'center' }}>
                <img src={logo} alt="Logo" style={{ maxWidth: '100%', height: 'auto' }} />
                {/* <Typography variant="body2">Pie del Drawer</Typography> */}
              </Box>}
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;